import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { entityName, PtoPolicySetupDataService } from '../data-services/pto-policy/setup';
import { SharedModule } from '../shared';
import { UIRouterModule } from '@uirouter/angular';
import { PtoPolicyRoute } from './pto-policy.route';
import { EntityDataService } from '@ngrx/data';



@NgModule({
    providers: [PtoPolicySetupDataService],
    imports: [
      CommonModule,
      SharedModule,
      UIRouterModule.forChild({
        states: [PtoPolicyRoute]
      })
    ]
  })
  export class PtoPolicyModule {
    constructor(
      entityDataService: EntityDataService,
      policySetupService: PtoPolicySetupDataService
    ) {
      entityDataService.registerService(entityName, policySetupService);
    }
  }
